import React, { Component } from 'react';
import { FormErrors } from './FormErrors';
import {FormError} from './FormError';
import {loadCsrf} from './common/CsrfFetcher';
import {Modal} from 'react-bootstrap';

class OrganizationInviteUsersBS3 extends Component {

  constructor (props) {

    super(props);
    this.state = {
      email0:'', email0Error:'', email0Valid:'false',
      email1:'', email1Error:'', email1Valid:'false',
      email2:'', email2Error:'', email2Valid:'false',
      email3:'', email3Error:'', email3Valid:'false',
      email4:'', email4Error:'', email4Valid:'false',
      email5:'', email5Error:'', email5Valid:'false',
      email6:'', email6Error:'', email6Valid:'false',
      email7:'', email7Error:'', email7Valid:'false',
      email8:'', email8Error:'', email8Valid:'false',
      email9:'', email9Error:'', email9Valid:'false',

      genericFormLevelProblems:'',
      currentCount: 1,
      formValid: false,
      csrfToken:'',
      csrfTokenHeaderName:'',

      showModal:false,

      emails:[{
          value:'',
          inputName:'email',
          error:'',
          valid:'false'
      }]
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleAddNewUser = this.handleAddNewUser.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.hideClass= this.hideClass.bind(this);
    this.handleAlignErrors=this.handleAlignErrors.bind(this);

  }

  componentDidMount() {
    loadCsrf(this.setCsrfState);
  }

  setCsrfState = (csrfToken, csrfHeaderValue)=>{
    var state = this.state;
    state.csrfToken = csrfToken;
    this.csrfHeaderValue = csrfHeaderValue;
    this.setState({
      state
    });
  }

  handleUserInput(e) {
    console.log("handling user input.... " + e.target.name + " value " + e.target.value);
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value, genericFormLevelProblems:''},

                  () => { this.validateField(name, value) });
  }

  handleCancel(event){
    event.preventDefault();
    console.log("cancelling this form");
    //console.log("state of email0 " + state.email0);
    window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/organization/manageUsers";
  }


  // Add New User button was clicked, so provide another textfield to enter an email. Limit 10.
  handleAddNewUser(event){
    var currentLocation = this.state.currentCount;
    currentLocation = ++currentLocation;

    this.setState({
      ...this.state,
      currentCount: currentLocation
    });

  }

  handleAlignErrors(location, json){
    let varNameSpace = {}; // set temp namespace to avoid eval use

    var rejectedValue = json.validationErrors[location].rejectedValue;

    for(var formPosition = 0; formPosition<10; formPosition++){
      var fieldName = 'this.state.email' + formPosition;
      var errorFieldName = 'email' + formPosition + 'Error';
      var validFieldName = 'email' + formPosition + 'Valid';

      // eval to be avoided using temp namespace
      // if(rejectedValue === eval(fieldName)){
      if(rejectedValue === varNameSpace[fieldName]){
        this.setState({
                      [errorFieldName]:json.validationErrors[location].message,
                      [validFieldName]:'false'
                      });
      }
    }
  }

  handleSubmit(event){
    event.preventDefault();

    let varNameSpace = {}; // set temp namespace to avoid eval use

    var isFormValid = this.state.email0Valid && this.state.email1Valid && this.state.email2Valid && this.state.email3Valid
      && this.state.email4Valid && this.state.email5Valid && this.state.email6Valid && this.state.email7Valid
      && this.state.email8Valid && this.state.email9Valid;


    if(isFormValid){
      //var inviteUsersData = {"email": this.state.email0 };
      var emailList = [];
      for(var i=0; i<10; i++){
        var fieldName = 'this.state.email' + i;
        // eval to be avoided using temp namespace
        // emailList.push(eval(fieldName));
        emailList.push(varNameSpace[fieldName]);
      }
      //clear out empty emails
      emailList = emailList.filter(function(n){ return n !== '' });

      var inviteUsersData = { "emails": emailList };
      var csrfToken = this.state.csrfToken;

      fetch(process.env.REACT_APP_HOST_API_URL + "/developer/mvc/api/organization/inviteUsers", {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(inviteUsersData)
      })
      .then(response=> {
        if (!response.ok) {
          console.log("response is not ok " + response.statusText  + " with status of " + response.status);
          if(response.status === 400 ){
            return response.json();
          }
          else if (response.status === 423){
              window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=organizationUserAdd.usageLimitsExceeced";
              return null;
          }
          else if(response.status === 401){
            window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/auth/login";
            return null;
          }
          throw new Error("Unknown Problem occurred : " + response.statusText);
        }
        window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/organization/manageUsers";
      })
      .then(json=>{
        if(json != null){
          if(json.errorCode === 'IneligibleToJoinOrgException'){

            for(var i =0; i<json.validationErrors.length; i++){
              this.handleAlignErrors(i, json);
            }

          } else {
            this.setState({
                          genericFormLevelProblems:['Error: Something went wrong, please try again.' + json.errorCode]
                          });
          }
        }
      })
      .catch(error => {
          console.log("Uh oh.... didn't work " + error.message);
          window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
          return Promise.reject();
      });
    }
    else{
      console.log("form is not valid.... will not submit");
      this.setState({
                    genericFormLevelProblems:['Error: Please correct any incorrect email addresses before you submit']
                    });

    }
  }

  validateField(fieldName, value) {
    console.log("validateField fieldName: " + fieldName + " fieldValue " + value );

    let emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
    if(value === ''){
      emailValid = true;
    }

    let emailError = emailValid ? '' : 'Error: Must contain a valid e-mail.';
    let fieldErrorName = fieldName+'Error';
    let fieldValidName = fieldName+'Valid';


    this.setState({[fieldErrorName]: emailError,
                    [fieldValidName]: emailValid,
                  }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.email0Valid && this.state.email1Valid && this.state.email2Valid && this.state.email3Valid && this.state.email4Valid && this.state.email5Valid && this.state.email6Valid && this.state.email7Valid && this.state.email8Valid && this.state.email9Valid} );
  }


  handleShowModal =(e) =>	{
    console.log("Trying to show a modal now.... ");

	  this.setState({
		  ...this.state,
		  showModal: !this.state.showModal
	  })
  }

  handleHideModal =(e) =>	{
    this.setState({
		  ...this.state,
		  showModal: false
	  })

  }

  handleCloseModal = (e) => {
    const name = e.target.name;
    if(name === 'YES'){
      this.handleSubmit(e);

    }
	  this.setState({
		  ...this.state,
		  showModal: !this.state.showModal,
	  })

  }


  errorClass(error) {
    return(error.length === 0 ? 'has-success' : 'has-error');
  }

  hideClass(location){
    if(this.state.currentCount<=location){
      return 'hide';
    }
    else{
      return 'show';
    }
  }

  render () {
    return (
      <div>


      <form id="orgnizationInviteUsersForm" name="orgnizationInviteUsersForm" className="customForm">

        <FormErrors formErrors={this.state.genericFormLevelProblems} />
        <label htmlFor="text_email">Enter User E-mail</label>

        <div className={`form-group help-block ${this.hideClass(0)} ${this.errorClass(this.state.email0Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email0Error} />
          <input id="emailAddresses_0" type="text" className="form-control" name="email0"
            placeholder="Email Address"
            value={this.state.email0}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>

        <div className={`form-group help-block ${this.hideClass(1)} ${this.errorClass(this.state.email1Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email1Error} />
          <input id="emailAddresses_1" type="text" className="form-control" name="email1"
            placeholder="Email Address"
            value={this.state.email1}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>

        <div className={`form-group help-block ${this.hideClass(2)} ${this.errorClass(this.state.email2Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email2Error} />
          <input id="emailAddresses_2" type="text" className="form-control" name="email2"
            placeholder="Email Address"
            value={this.state.email2}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>

        <div className={`form-group help-block ${this.hideClass(3)} ${this.errorClass(this.state.email3Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email3Error} />
          <input id="emailAddresses_3" type="text" className="form-control" name="email3"
            placeholder="Email Address"
            value={this.state.email3}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>

        <div className={`form-group help-block ${this.hideClass(4)} ${this.errorClass(this.state.email4Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email4Error} />
          <input id="emailAddresses_4" type="text" className="form-control" name="email4"
            placeholder="Email Address"
            value={this.state.email4}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>


        <div className={`form-group help-block ${this.hideClass(5)} ${this.errorClass(this.state.email5Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email5Error} />
          <input id="emailAddresses_5" type="text" className="form-control" name="email5"
            placeholder="Email Address"
            value={this.state.email5}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>



        <div className={`form-group help-block ${this.hideClass(6)} ${this.errorClass(this.state.email6Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email6Error} />
          <input id="emailAddresses_6" type="text" className="form-control" name="email6"
            placeholder="Email Address"
            value={this.state.email6}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>


        <div className={`form-group help-block ${this.hideClass(7)} ${this.errorClass(this.state.email7Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email7Error} />
          <input id="emailAddresses_7" type="text" className="form-control" name="email7"
            placeholder="Email Address"
            value={this.state.email7}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>


        <div className={`form-group help-block ${this.hideClass(8)} ${this.errorClass(this.state.email8Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email8Error} />
          <input id="emailAddresses_8" type="text" className="form-control" name="email8"
            placeholder="Email Address"
            value={this.state.email8}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>


        <div className={`form-group help-block ${this.hideClass(9)} ${this.errorClass(this.state.email9Error)}`}>

          <FormError hasHtml="true" errorMessage={this.state.email9Error} />
          <input id="emailAddresses_9" type="text" className="form-control" name="email9"
            placeholder="Email Address"
            value={this.state.email9}
            onChange={this.handleUserInput}
            autoFocus="autoFocus"
            maxLength="45"
            />
        </div>

				<div className="form-group">
					<button type="button" id="addNewUserButton" onClick={this.handleAddNewUser} className="button secondary light-bg variableWidth" aria-label="Add New User"><strong>+</strong></button>
					<label htmlFor="addNewUserButton">Add New User</label>
				</div>

        <div className="pull-left">
          <button type="button" className="button secondary light-bg" onClick={this.handleCancel}>Cancel</button>
        </div>
        <div className="pull-right">
          <button type="button" className="button secondary light-bg" onClick={this.handleShowModal}>Submit</button>
        </div>

          <Modal onHide={this.handleHideModal} show={this.state.showModal} aria-labelledby="ModalHeader">
            <Modal.Header closeButton>
              <Modal.Title id='ModalHeader'>Invite Users to Your Organization</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to invite these users to your Organization?</p>
            </Modal.Body>
            <Modal.Footer>
              <button className='button secondary light-bg' onClick={this.handleCloseModal} name="YES">
                Yes
              </button>
              <button className='button secondary light-bg' onClick={this.handleHideModal} name="NO">
                No
              </button>
            </Modal.Footer>
          </Modal>
      </form>
      </div>
    )
  }
}

export default OrganizationInviteUsersBS3;



// WEBPACK FOOTER //
// ./src/OrganizationInviteUsersBS3.js